import { selectPath } from '../../selectors/page';
import { selectPageMeta } from '../../selectors/seo';
import { IBrowserHistoryState } from '../../types/browserHistory';
import { TThunkAction } from '../../types/redux/thunk';
import { isBrowser } from '../../utils/isBrowser';

export const updateBrowserHistory = (): TThunkAction<void> => (_dispatch, getState) => {
  const state = getState();

  const path = selectPath(state);
  const seoData = selectPageMeta(state);
  const title = seoData.title;

  const data: IBrowserHistoryState = {
    path,
  };

  if (isBrowser()) {
    window.history.pushState(data, title, path);
  }
};
